export const CLIENT_PROFILE_DETAILS_ENTRY_STATUS = {
  NOT_FOUND: 'Change status operation could not be done',
};


// WEBPACK FOOTER //
// ./src/features/client-profile/constants/clientProfileEntryDetailsStatusMessages copy.js